export default __webpack_public_path__ + "777fdb49b05a9d091fdbff1b32d2aea7.png";